export function mmenu() {
  
  $(document).ready(function () {
  
    $('a[href="#mmenu"]').click(function () {
        
      var hh = $("header .header-inner").height();
      
      $("#mobileNav").css("margin-top", hh);
      $("#mobileNav .overlay-content").css("margin-bottom", hh);
      
      
      if($(this).hasClass("open")) {
        $("#mobileNav").height("0");
        $('header .header-additional-mobile').slideDown("fast");
        if($("#announcement-bar").length)
          $("#announcement-bar").show();
      }
      else {
        $("#mobileNav").height("100%");
        $('header .header-additional-mobile').slideUp("fast");
        if($("#announcement-bar").length)
          $("#announcement-bar").hide();
      }

      $(this).toggleClass("open");
      $('html,body').toggleClass("noscroll");

    });
    
    $("button.sub-toggle").click(function () {
      if($(this).hasClass("open")) {
        $(this).parent().find(".sub_menu").slideUp();
      }
      else {
        $(this).parent().find(".sub_menu").slideDown();
        $(this).parent().find("> a").focus();
      }
      $(this).toggleClass("open");
      $(this).parent().toggleClass("collapsed");
    });

    $(".menu-item-has-children a").click(function() {
      if($(this).attr("href") == '#')
        $(this).parent().find("button").click();
    });
    
    $('.footer-menu-header').click(function() {
      
      if($(this).hasClass("open"))
        $(this).parent().find(".footer-menu").slideUp();
      else {
        $(this).parent().find(".footer-menu").slideDown();
      }
      $(this).toggleClass("open");
      $(this).parent().toggleClass("collapsed");
    });
  
  });
	
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobile-menu.js